/* ==========================================================
   SAFE DYNAMIC COLLECTION-BASED AJAX UPSELL & FREE SHIPPING BAR
   Mobile Mega Menu Safe Version
   - Removed global .drawer z-index
   - Removed global body/html touch-action:none
   - Scoped cart drawer CSS only to cart drawer
   - Added duplicate-init protection
========================================================== */

(function () {
    if (window.__safeBrandUpsellInitialized) return;
    window.__safeBrandUpsellInitialized = true;

    let isFetching = false;
    let isFetchingShipping = false;

    // ==========================================
    // SAFE SCOPED CSS
    // ==========================================
    const style = document.createElement('style');
    style.innerHTML = `
        /* Upsell Slider */
        .upsell-slider-container {
            display: flex;
            overflow-x: auto;
            scroll-snap-type: x mandatory;
            gap: 10px;
            padding-bottom: 10px;
            -webkit-overflow-scrolling: touch;
            cursor: grab;
        }

        .upsell-slider-container.is-dragging {
            scroll-snap-type: none;
            cursor: grabbing;
        }

        .upsell-slider-container::-webkit-scrollbar {
            height: 8px;
        }

        .upsell-slider-container::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        .upsell-slider-container::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 4px;
            cursor: pointer;
        }

        .upsell-slider-container::-webkit-scrollbar-thumb:hover {
            background: #a8a8a8;
        }

        /* Cart Drawer only - do not target generic .drawer */
        #shopify-section-cart-drawer,
        #CartDrawer,
        .cart-drawer {
            z-index: 99999 !important;
        }

        /* Lower sticky add to cart only */
        .product-sticky-bar,
        .sticky-add-to-cart,
        [data-sticky-add-to-cart],
        .product__submit__buttons {
            z-index: 99 !important;
        }

        /* Cart drawer content only */
        #CartDrawer .drawer__inner,
        #CartDrawer .cart-drawer__inner,
        #CartDrawer .cart-drawer__content,
        #CartDrawer .js-mini-cart-content,
        .cart-drawer .drawer__inner,
        .cart-drawer .cart-drawer__inner,
        .cart-drawer .cart-drawer__content,
        .cart-drawer .js-mini-cart-content {
            overscroll-behavior-y: contain !important;
            -webkit-overflow-scrolling: touch !important;
        }

        /* Cart footer only */
        #CartDrawer .drawer__footer,
        #CartDrawer .cart-drawer__footer,
        #CartDrawer .mini-cart__footer,
        .cart-drawer .drawer__footer,
        .cart-drawer .cart-drawer__footer,
        .cart-drawer .mini-cart__footer {
            position: sticky !important;
            bottom: 0 !important;
            background: #ffffff !important;
            z-index: 99999 !important;
            box-shadow: 0 -4px 15px rgba(0,0,0,0.05) !important;
        }

        .upsell-title-truncate {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    `;
    document.head.appendChild(style);

    // ==========================================
    // HELPERS
    // ==========================================
    function getCartContent() {
        return document.querySelector(
            '#CartDrawer .js-mini-cart-content, .cart-drawer .js-mini-cart-content, .js-mini-cart-content'
        );
    }

    function triggerCartUpdated() {
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    }

    // ==========================================
    // SAFE FETCH INTERCEPTOR
    // ==========================================
    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
        const response = await originalFetch.apply(this, args);

        try {
            const url = typeof args[0] === 'string'
                ? args[0]
                : args[0] && args[0].url
                    ? args[0].url
                    : '';

            if (
                url.includes('/cart/change') ||
                url.includes('/cart/update') ||
                url.includes('/cart/add') ||
                url.includes('/cart/clear')
            ) {
                setTimeout(function () {
                    reinjectShippingBar();
                }, 400);
            }
        } catch (e) {}

        return response;
    };

    // ==========================================
    // OBSERVER - SAFE
    // ==========================================
    const observer = new MutationObserver(function () {
        const container = document.getElementById('dynamic-brand-upsell');

        if (container && container.innerHTML.trim() === '' && !isFetching) {
            renderApp();
        }

        const cartContent = getCartContent();
        const shippingBar = document.getElementById('custom-free-shipping-bar');

        if (cartContent && !shippingBar && !isFetchingShipping) {
            reinjectShippingBar();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    document.addEventListener('cart:updated', function () {
        const container = document.getElementById('dynamic-brand-upsell');

        if (container) {
            container.innerHTML = '';
        }

        reinjectShippingBar();
    });

    // ==========================================
    // FREE SHIPPING BAR LOGIC
    // ==========================================
    function updateFreeShippingBar(cart) {
        let container = document.getElementById('custom-free-shipping-bar');
        const cartContent = getCartContent();

        if (!cartContent) return;

        if (!container) {
            container = document.createElement('div');
            container.id = 'custom-free-shipping-bar';
            container.style.padding = '12px 15px';
            container.style.backgroundColor = '#fdfbf7';
            container.style.borderBottom = '1px solid #eaeaea';
            container.style.marginBottom = '15px';

            cartContent.parentNode.insertBefore(container, cartContent);
        }

        const threshold = 5000;
        const total = cart.total_price || 0;
        const gap = threshold - total;

        let percent = (total / threshold) * 100;
        if (percent > 100) percent = 100;
        if (percent < 0) percent = 0;

        let messageHtml = '';

        if (gap > 0) {
            const gapMoney = (gap / 100).toFixed(2);
            messageHtml = `
                <p style="margin: 0 0 8px; font-size: 13px; text-align: center; font-weight: bold; color: #111;">
                    You're only <span style="color: #541587;">$${gapMoney}</span> away from FREE SHIPPING!
                </p>
            `;
        } else {
            messageHtml = `
                <p style="margin: 0 0 8px; font-size: 13px; text-align: center; font-weight: bold; color: #C49A45;">
                    Congratulations! You've unlocked FREE SHIPPING!
                </p>
            `;
        }

        const barHtml = `
            <div style="width: 100%; height: 6px; background: #e0e0e0; border-radius: 4px; overflow: hidden;">
                <div style="width: ${percent}%; height: 100%; background: ${gap > 0 ? '#541587' : '#C49A45'}; transition: width 0.4s ease;"></div>
            </div>
        `;

        container.innerHTML = messageHtml + barHtml;
    }

    async function reinjectShippingBar() {
        if (isFetchingShipping) return;

        isFetchingShipping = true;

        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();
            updateFreeShippingBar(cart);
        } catch (e) {}

        isFetchingShipping = false;
    }

    // ==========================================
    // RENDER UPSELL APP
    // ==========================================
    async function renderApp() {
        const container = document.getElementById('dynamic-brand-upsell');

        if (!container || isFetching) return;

        isFetching = true;

        container.innerHTML = `
            <div style="text-align:center; padding:10px;">
                <div class="spinner-border" style="width: 1.5rem; height: 1.5rem; color:#541587;" role="status"></div>
            </div>
        `;

        try {
            const cartRes = await fetch('/cart.js');
            const cart = await cartRes.json();

            updateFreeShippingBar(cart);

            if (!cart.items || cart.items.length === 0) {
                container.innerHTML = '';
                isFetching = false;
                return;
            }

            const firstItemHandle = cart.items[0].handle;
            const itemFullRes = await fetch(`/products/${firstItemHandle}.js`);
            const itemFullData = await itemFullRes.json();

            const firstItemTitle = cart.items[0].title.toLowerCase();
            const itemTags = itemFullData.tags
                ? itemFullData.tags.map(function (tag) {
                    return tag.toLowerCase();
                })
                : [];

            let targetBrandDisplay = '';
            let brandKeyword = '';

            if (firstItemTitle.includes("loc'd 4 lyfe") || firstItemTitle.includes("loc'd")) {
                targetBrandDisplay = "Loc'd 4 Lyfe";
                brandKeyword = "loc'd";
            } else if (firstItemTitle.includes('moisturcurl')) {
                targetBrandDisplay = 'MoisturCurl';
                brandKeyword = 'moisturcurl';
            } else if (firstItemTitle.includes('good2gro')) {
                targetBrandDisplay = 'GOOD2GRO';
                brandKeyword = 'good2gro';
            } else if (firstItemTitle.includes('resilience')) {
                targetBrandDisplay = 'Resilience';
                brandKeyword = 'resilience';
            } else {
                if (itemTags.some(function (tag) {
                    return tag.includes("loc'd") || tag.includes('locs');
                })) {
                    targetBrandDisplay = "Loc'd 4 Lyfe";
                    brandKeyword = "loc'd";
                } else if (itemTags.includes('moisturcurl')) {
                    targetBrandDisplay = 'MoisturCurl';
                    brandKeyword = 'moisturcurl';
                } else if (itemTags.includes('good2gro')) {
                    targetBrandDisplay = 'GOOD2GRO';
                    brandKeyword = 'good2gro';
                } else if (itemTags.includes('resilience')) {
                    targetBrandDisplay = 'Resilience';
                    brandKeyword = 'resilience';
                } else {
                    targetBrandDisplay = 'Our Collections';
                    brandKeyword = 'all';
                }
            }

            const cartProductIds = new Set(cart.items.map(function (item) {
                return item.product_id;
            }));

            const productRes = await fetch('/products.json?limit=250');
            const productData = await productRes.json();

            const finalProducts = [];
            const uniqueProductIds = new Set();

            function filterProduct(product) {
                if (brandKeyword !== 'all') {
                    const productTags = product.tags.map(function (tag) {
                        return tag.toLowerCase();
                    });

                    const productTitle = product.title.toLowerCase();

                    const matchesTag = productTags.some(function (tag) {
                        return tag.includes(brandKeyword);
                    });

                    const matchesTitle = productTitle.includes(brandKeyword);

                    if (!matchesTag && !matchesTitle) return false;
                }

                if (cartProductIds.has(product.id)) return false;
                if (uniqueProductIds.has(product.id)) return false;

                return true;
            }

            for (const product of productData.products) {
                if (filterProduct(product) && finalProducts.length < 4) {
                    uniqueProductIds.add(product.id);
                    finalProducts.push(product);
                }
            }

            if (finalProducts.length === 0) {
                container.innerHTML = '';
                isFetching = false;
                return;
            }

            let html = `
                <h4 style="font-size: 15px; font-weight: bold; margin-bottom: 12px; color: #000; text-align: left;">
                    Pairs well with ${targetBrandDisplay}
                </h4>
            `;

            html += `<div class="upsell-slider-container">`;

            finalProducts.forEach(function (product) {
                const price = product.variants[0].price;
                const variantId = product.variants[0].id;
                const image = product.images && product.images[0] ? product.images[0].src : '';
                const url = '/products/' + product.handle;
                const title = product.title.replace(/"/g, '&quot;');

                html += `
                    <div class="brand-upsell-item" style="flex: 0 0 85%; scroll-snap-align: start; display:flex; align-items:center; gap:12px; background:#fff; padding:10px; border-radius:4px; border:1px solid #eaeaea; transition: opacity 0.3s ease;">
                        <a href="${url}">
                            <img src="${image}" style="width:65px; height:65px; min-width: 65px; object-fit:contain; border-radius:4px;" alt="${title}">
                        </a>

                        <div style="flex-grow:1; text-align: left; overflow: hidden;">
                            <a href="${url}" class="upsell-title-truncate" style="font-size:13px; font-weight:600; color:#111; text-decoration:none; margin-bottom:4px; line-height: 1.3;">
                                ${title}
                            </a>
                            <p style="font-size:12px; color:#555; margin:0;">$${price} USD</p>
                        </div>

                        <button class="brand-upsell-btn" data-variant-id="${variantId}" style="background:#541587; color:#fff; border:none; padding:8px 15px; font-size:11px; font-weight:700; cursor:pointer; border-radius:2px; min-width: 65px;">
                            + ADD
                        </button>
                    </div>
                `;
            });

            html += `</div>`;

            container.innerHTML = html;

            document.querySelectorAll('.brand-upsell-btn').forEach(function (btn) {
                btn.addEventListener('click', async function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const variantId = this.getAttribute('data-variant-id');
                    const originalText = this.innerText;

                    this.innerText = 'ADDING...';
                    this.disabled = true;

                    try {
                        const addRes = await fetch('/cart/add.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                items: [
                                    {
                                        id: variantId,
                                        quantity: 1
                                    }
                                ]
                            })
                        });

                        if (addRes.ok) {
                            this.innerText = 'ADDED ✓';
                            this.style.background = '#2e8b57';

                            const updatedCartRes = await fetch('/cart.js');
                            const updatedCart = await updatedCartRes.json();

                            updateFreeShippingBar(updatedCart);

                            const priceStr = (updatedCart.total_price / 100).toFixed(2);

                            document.querySelectorAll('.js-cart-total, [data-cart-total]').forEach(function (el) {
                                el.innerHTML = '$' + priceStr + ' USD';
                            });

                            document.querySelectorAll('.js-cart-count, [data-cart-count]').forEach(function (el) {
                                el.innerHTML = updatedCart.item_count;
                            });

                            const cartList = getCartContent();
                            const addedItem = updatedCart.items.find(function (item) {
                                return item.variant_id == variantId;
                            });

                            if (cartList && addedItem) {
                                const itemImg = addedItem.image ? addedItem.image : '';
                                const itemKey = addedItem.key;
                                const itemTitle = addedItem.title.replace(/"/g, '&quot;');

                                const newCartItemHtml = `
                                    <div class="mini-cart-item d-flex mb-4 align-items-center" style="animation: fadeIn 0.4s ease-in-out;">
                                        <div class="mini-cart-image pr-3" style="flex: 0 0 100px;">
                                            <a href="${addedItem.url}">
                                                <img src="${itemImg}" alt="${itemTitle}" style="width: 100%; border-radius: 4px; border: 1px solid #f5f5f5;">
                                            </a>
                                        </div>

                                        <div class="mini-cart-meta" style="flex: 1; text-align: left;">
                                            <a href="${addedItem.url}" style="font-size: 13px; font-weight: 600; color: #000; margin-bottom: 5px; display: block; text-decoration: none; line-height: 1.3;">
                                                ${addedItem.title}
                                            </a>

                                            <p class="custom-upsell-price-line" style="font-size: 13px; color: #666; margin-bottom: 10px;">
                                                $${(addedItem.price / 100).toFixed(2)} USD x ${addedItem.quantity}
                                            </p>

                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="custom-upsell-qty-wrapper" style="border: 1px solid #ddd; display: flex; align-items: center; border-radius: 2px; background: #fff; height: 26px;">
                                                    <button class="custom-upsell-qty-btn minus" data-key="${itemKey}" style="border: none; background: transparent; padding: 0 8px; cursor: pointer; font-size: 15px; color: #333; outline: none;">&minus;</button>
                                                    <span class="custom-upsell-qty-val" style="font-size: 13px; padding: 0 5px; min-width: 20px; text-align: center; color: #000; font-weight: 500;">${addedItem.quantity}</span>
                                                    <button class="custom-upsell-qty-btn plus" data-key="${itemKey}" style="border: none; background: transparent; padding: 0 8px; cursor: pointer; font-size: 15px; color: #333; outline: none;">&plus;</button>
                                                </div>

                                                <a href="#" class="custom-upsell-remove" data-key="${itemKey}" style="font-size: 11px; text-decoration: underline; color: #777; text-transform: uppercase;">
                                                    Remove
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                `;

                                cartList.insertAdjacentHTML('beforeend', newCartItemHtml);
                            }

                            triggerCartUpdated();

                            const upsellBox = this.closest('.brand-upsell-item');

                            if (upsellBox) {
                                upsellBox.style.opacity = '0';
                                setTimeout(function () {
                                    upsellBox.remove();
                                }, 300);
                            }
                        } else {
                            this.innerText = 'ERROR';

                            setTimeout(() => {
                                this.innerText = originalText;
                                this.disabled = false;
                            }, 2000);
                        }
                    } catch (err) {
                        this.innerText = 'ERROR';

                        setTimeout(() => {
                            this.innerText = originalText;
                            this.disabled = false;
                        }, 2000);
                    }
                });
            });
        } catch (e) {
            container.innerHTML = '';
        } finally {
            isFetching = false;
        }
    }

    // ==========================================
    // SAFE CUSTOM REMOVE LOGIC
    // ==========================================
    document.addEventListener('click', async function (e) {
        const removeBtn = e.target.closest('.custom-upsell-remove');
        if (!removeBtn) return;

        e.preventDefault();
        e.stopPropagation();

        const key = removeBtn.getAttribute('data-key');

        removeBtn.innerText = '...';
        removeBtn.style.pointerEvents = 'none';

        try {
            const res = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: key,
                    quantity: 0
                })
            });

            if (res.ok) {
                const updatedCart = await res.json();

                updateFreeShippingBar(updatedCart);

                const itemDom = removeBtn.closest('.mini-cart-item');

                if (itemDom) {
                    itemDom.style.opacity = '0';
                    itemDom.style.transition = 'opacity 0.3s ease';

                    setTimeout(function () {
                        itemDom.remove();
                    }, 300);
                }

                document.querySelectorAll('.js-cart-count, [data-cart-count]').forEach(function (el) {
                    el.innerHTML = updatedCart.item_count;
                });

                const priceStr = (updatedCart.total_price / 100).toFixed(2);

                document.querySelectorAll('.js-cart-total, [data-cart-total]').forEach(function (el) {
                    el.innerHTML = '$' + priceStr + ' USD';
                });

                const upsellContainer = document.getElementById('dynamic-brand-upsell');

                if (upsellContainer) {
                    upsellContainer.innerHTML = '';
                }

                triggerCartUpdated();
            }
        } catch (err) {}
    });

    // ==========================================
    // SAFE CUSTOM QUANTITY LOGIC
    // ==========================================
    document.addEventListener('click', async function (e) {
        const qtyBtn = e.target.closest('.custom-upsell-qty-btn');
        if (!qtyBtn) return;

        e.preventDefault();
        e.stopPropagation();

        const isPlus = qtyBtn.classList.contains('plus');
        const key = qtyBtn.getAttribute('data-key');
        const valSpan = qtyBtn.parentElement.querySelector('.custom-upsell-qty-val');

        if (!valSpan) return;

        const currentQty = parseInt(valSpan.innerText, 10);

        if (isNaN(currentQty)) return;

        let newQty = isPlus ? currentQty + 1 : currentQty - 1;

        if (newQty < 1) newQty = 1;
        if (newQty === currentQty) return;

        valSpan.innerText = '..';
        qtyBtn.style.pointerEvents = 'none';

        try {
            const res = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: key,
                    quantity: newQty
                })
            });

            if (res.ok) {
                const updatedCart = await res.json();

                valSpan.innerText = newQty;

                document.querySelectorAll('.js-cart-count, [data-cart-count]').forEach(function (el) {
                    el.innerHTML = updatedCart.item_count;
                });

                const priceStr = (updatedCart.total_price / 100).toFixed(2);

                document.querySelectorAll('.js-cart-total, [data-cart-total]').forEach(function (el) {
                    el.innerHTML = '$' + priceStr + ' USD';
                });

                const updatedItem = updatedCart.items.find(function (item) {
                    return item.key === key;
                });

                if (updatedItem) {
                    const metaDiv = qtyBtn.closest('.mini-cart-meta');

                    if (metaDiv) {
                        const priceP = metaDiv.querySelector('.custom-upsell-price-line');

                        if (priceP) {
                            priceP.innerHTML = `$${(updatedItem.price / 100).toFixed(2)} USD x ${updatedItem.quantity}`;
                        }
                    }
                }

                updateFreeShippingBar(updatedCart);
                triggerCartUpdated();
            } else {
                valSpan.innerText = currentQty;
            }
        } catch (err) {
            valSpan.innerText = currentQty;
        } finally {
            qtyBtn.style.pointerEvents = 'auto';
        }
    });

    // ==========================================
    // DESKTOP DRAG TO SCROLL
    // ==========================================
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let activeSlider = null;

    document.addEventListener('mousedown', function (e) {
        const slider = e.target.closest('.upsell-slider-container');

        if (!slider) return;
        if (e.target.closest('button') || e.target.closest('a')) return;

        isDown = true;
        activeSlider = slider;
        activeSlider.classList.add('is-dragging');

        startX = e.pageX - activeSlider.offsetLeft;
        scrollLeft = activeSlider.scrollLeft;
    });

    document.addEventListener('mouseleave', function () {
        if (!isDown || !activeSlider) return;

        isDown = false;
        activeSlider.classList.remove('is-dragging');
        activeSlider = null;
    });

    document.addEventListener('mouseup', function () {
        if (!isDown || !activeSlider) return;

        isDown = false;
        activeSlider.classList.remove('is-dragging');
        activeSlider = null;
    });

    document.addEventListener('mousemove', function (e) {
        if (!isDown || !activeSlider) return;

        e.preventDefault();

        const x = e.pageX - activeSlider.offsetLeft;
        const walk = (x - startX) * 1.5;

        activeSlider.scrollLeft = scrollLeft - walk;
    });

    // Initial load
    setTimeout(function () {
        reinjectShippingBar();

        const container = document.getElementById('dynamic-brand-upsell');

        if (container) {
            renderApp();
        }
    }, 500);
})();